// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Car from '../_raw/service/icon_car.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Car);
